// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__nlnru","col":"styles_col__3_vrj"};